<tp-modal dialogTitle="Change Access Level" [isBusy]="isSubmitting$ | async">
  <p>Change access level for user '{{ this.data.user.email }}' in space '{{ this.data.space.name }}'</p>
  <br/>
  <tp-form [formGroup]="form" [isSubmitting$]="isSubmitting$" (doSubmit)="submit()">
    <tp-form-select [form]="form" field="accessLevel" label="Access Level" [options]="accessLevelOptions"/>
    <tp-form-actions
      [submitDisabled]="form.value.accessLevel == data.user.accessLevel"
      [cancellable]="true" submitText="Submit" [isSubmitting]="isSubmitting$ | async"
      buttonIdPrefix="spaceSetUserAccessModal" (cancel)="close()"
    />
  </tp-form>
</tp-modal>
